'use strict';

import React from "react";
import Moment from "moment";
var $ = require('jquery');

export default class Message extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            Message: 'loading',
            MessageTime: '',
            MessageUser: ''
        };
    }
    componentDidMount() {
        var methodName = 'Get MEssage';
        var urlmessage = "message/get?messageId=" + this.props.messageId;

        this.serverRequest = $.get(urlmessage, function (result) {
            console.log('[INFO], ', methodName);
            var message, messageTime,messageUser= "";
            try {
                var data = result; //var data = JSON.parse(result);
                //console.log(data);
                message = data.content;
                messageTime = Moment(data.time).format('DD/MM/YYYY à hh:mm:ss');
                messageUser= data.user;
            } catch (e) {
                // les instructions utilisées pour gérer les exceptions
                console.log('[ERROR], ', methodName, ',Parsing data from serveur ');
                console.log(e); // on transfère l'objet de l'exception à une méthode
                return;
            }

            this.setState({Message: message, MessageTime: messageTime, MessageUser: messageUser});
        }.bind(this));
    }
    render() {
        let side = "lv-item media left";
        let sideAvatar = "lv-avatar pull-left";
        if (this.state.MessageUser == this.props.pointOfView){ //If Admin or not
            side = "lv-item media right";
            sideAvatar = "lv-avatar pull-right";
        }
        return (
            <div className={side}>
                <div className={sideAvatar}>
                    <img src="" alt=""/>
                </div>
                <div className="media-body">
                    <div className="ms-item">
                        {this.state.Message}
                    </div>
                    <small className="ms-date">
                        <i className="zmdi zmdi-access-time"></i>
                        {this.state.MessageTime}</small>
                </div>
            </div>
        )
    }

}

//module.exports = Message;
